import React, {
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import GlobalContext from "../../framework/GlobalContext";
import Button from "../../framework/Button";
import Checkbox from "../../framework/Checkbox";
import Autocomplete from "../../framework/Autocomplete";
import images from "../../assets/images";
import { fetchRoles, updateRole } from "../../services/roles-service";
import { privilege_groups, roleColDefsForExport } from "./constants";
import classes from "./index.module.css";
import EditRole from "./EditRole";
import RoleLogs from "./RoleLogs";
import Aggrid from "../../framework/AgGrid";
const Roles = () => {
  const { displayModal } = useContext(GlobalContext);
  const { editIcon, deleteDetail } = images;
  const [allRoles, setAllRoles] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showLogs, setShowLogs] = useState(false);
  const [editRoleId, setEditRoleId] = useState(null);

  const [api, setApi] = useState(null);

  const closeShowLogsAC = useCallback(() => {
    setShowLogs(false);
  }, []);
  const refresh = useCallback(() => {
    fetchRoles(`deleted=false`).then((r) => {
      if (r.status === "success") {
        setAllRoles(r.result);
      }
    });
  }, []);
  const saveRoles = useCallback((payload) => {
    return updateRole(payload).then((r) => {
      if (r.status === "success") {
        setShowEditModal(false);
      }
    });
  }, []);
  const updateAllPrivileges = useCallback(
    (e, role, group, index) => {
      let updatedPrivileges = role.privileges;
      group.privileges.forEach((p) => {
        if (e.target.checked) {
          if (updatedPrivileges.findIndex((x) => x === p.id) === -1) {
            updatedPrivileges = [...updatedPrivileges, p.id];
          }
        } else {
          updatedPrivileges = updatedPrivileges.filter((x) => x !== p.id);
        }
      });
      saveRoles({ _id: role._id, privileges: updatedPrivileges });
      setAllRoles((prev) => {
        prev[index].privileges = updatedPrivileges;
        return [...prev];
      });
    },
    [saveRoles]
  );
  const privilegeChangeHandler = useCallback(
    (e, role, privilege, index) => {
      let _privileges = role.privileges.slice();
      if (_privileges.findIndex((p) => p === privilege.id) !== -1) {
        _privileges = _privileges.filter(
          (_filtered) => _filtered !== privilege.id
        );
      } else {
        _privileges = [..._privileges, privilege.id];
      }
      saveRoles({ _id: role._id, privileges: _privileges });
      setAllRoles((prev) => {
        prev[index].privileges = _privileges;
        return [...prev];
      });
    },
    [saveRoles]
  );
  const addNewRole = useCallback(
    async (e, role) => {
      if (!role) return;
      saveRoles(role).then((r) => refresh());
    },
    [refresh, saveRoles]
  );
  const editRole = (role) => {
    setEditRoleId(role._id);
    setShowEditModal(true);
  };
  const deleteRole = async (role) => {
    if (
      await displayModal({
        type: "warn",
        title: "Are you sure you want to delete this role?",
      })
    ) {
      saveRoles({ _id: role._id, deleted: true, privileges: [] }).then((r) =>
        refresh()
      );
    }
  };
  const exportRoleData = useCallback(() => {
    api.exportDataAsCsv({ fileName: "roles-report" });
  }, [api]);
  const getTableData = () => {
    return (
      <table>
        <thead>
          <tr>
            <th>Privileges</th>
            {allRoles?.map((_roles) => {
              return (
                <th key={`role_key_${_roles._id}`}>
                  <div className={classes["roles-app-header-cell"]}>
                    {_roles.role}
                    <div className={classes["roles-app-header-cell-ctas"]}>
                      <div
                        className={classes["header-cell-cta"]}
                        onClick={() => editRole(_roles)}
                      >
                        <img
                          src={editIcon}
                          alt="edit role"
                          width={20}
                          height={20}
                        />
                      </div>
                      <div
                        className={classes["header-cell-cta"]}
                        onClick={() => deleteRole(_roles)}
                      >
                        <img
                          src={deleteDetail}
                          alt="delete role"
                          width={25}
                          height={25}
                        />
                      </div>
                    </div>
                  </div>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {privilege_groups.map((_pGroups, pgIndex) => {
            return (
              <Fragment key={`privilege_key_${_pGroups.groupId}`}>
                <tr>
                  <td>
                    <div
                      className={`${classes["roles-app-cell"]} ${classes["roles-app-group-header-cell"]}`}
                    >
                      {_pGroups.groupLabel}
                    </div>
                  </td>
                  {allRoles?.map((_roles, pgRIndex) => {
                    return (
                      <td key={`role_header_key_${_roles._id}`}>
                        <div
                          className={`${classes["roles-app-cell"]} ${classes["roles-app-group-header-cell"]}`}
                        >
                          <Checkbox
                            onChange={(e) =>
                              updateAllPrivileges(e, _roles, _pGroups, pgRIndex)
                            }
                          />
                        </div>
                      </td>
                    );
                  })}
                </tr>
                {_pGroups.privileges.map((_privileges) => {
                  return (
                    <tr key={`privilege_key_${_privileges.id}`}>
                      <td>
                        <div
                          className={`${classes["roles-app-cell"]} ${classes["privilege-container"]}`}
                        >
                          <div className={classes["roles-app-cell-label"]}>
                            {_privileges.label}
                          </div>
                          <div className={classes["roles-app-cell-desc"]}>
                            {_privileges.desc}
                          </div>
                        </div>
                      </td>
                      {allRoles?.map((_roles, index) => {
                        return (
                          <td key={`role_key_${_roles._id}`}>
                            <div className={`${classes["roles-app-cell"]}`}>
                              <Checkbox
                                checked={
                                  _roles.privileges.indexOf(_privileges.id) !==
                                  -1
                                }
                                onChange={(e) =>
                                  privilegeChangeHandler(
                                    e,
                                    _roles,
                                    _privileges,
                                    index
                                  )
                                }
                              />
                            </div>
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </Fragment>
            );
          })}
        </tbody>
      </table>
    );
  };
  useEffect(() => {
    if (!allRoles) refresh();
  }, [allRoles, refresh]);
  return (
    <div className={classes["roles-app"]}>
      <div className={classes["roles-app-body"]}>{getTableData()}</div>
      <div className={classes["roles-app-footer"]}>
        <Button
          label="Export"
          onClick={() => {
            exportRoleData();
          }}
        />
        <Button
          label="View Logs"
          onClick={() => {
            setShowLogs(true);
          }}
        />
        <Button
          label="Add New Role"
          color="violet"
          onClick={() => {
            setShowEditModal(true);
          }}
        />
      </div>
      <div
        style={{
          display: "none",
        }}
      >
        <Aggrid
          onGridReady={(params) => setApi(params.api)}
          columnDefs={roleColDefsForExport}
          rowData={allRoles}
        />
      </div>
      <EditRole
        id={editRoleId}
        showModal={showEditModal}
        onEscape={() => {
          setShowEditModal(false);
          setEditRoleId(null);
        }}
        onClick={addNewRole}
      />
      <Autocomplete
        show={showLogs}
        width="85%"
        height="60%"
        closeAutoComplete={closeShowLogsAC}
      >
        <RoleLogs onEscape={closeShowLogsAC} />
      </Autocomplete>
    </div>
  );
};

export default Roles;
